import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { TranslateService } from '@ngx-translate/core';
import { TEXT_AREA_STATE } from "../../providers/myria/app-variables";

@Component({
  selector: "rmt-text-area",
  templateUrl: "rmt-text-area.html",
})
export class RmtTextAreaComponent {
  @Input() content?: string;
  @Input() label?: string = "";
  @Input() helperText?: string;
  @Input() customCssClass?: string;
  @Input() errorHelperText?: string;
  @Input() warningHelperText?: string;
  @Input() successHelperText?: string;
  @Input() isDisabled: boolean = false;
  @Input() maxCharacters: number = 500;
  @ViewChild("textAreaInput") textAreaInput;
  @Output() onInputChange = new EventEmitter<string>();

  charCount: number = 0;
  isFocused: boolean = false;

  TEXT_AREA_STATE = TEXT_AREA_STATE;
  currentState = this.TEXT_AREA_STATE.DEFAULT;

  textAreaClass = "text-area-default";
  helperTextClass = "helper-text-default";
  helperTextIconName = "information-circle";
  counterTextClass = "counter-text-default";
  helperTextIconClass = "helper-text-icon-default";

  constructor(private translate: TranslateService) { }

  ngOnInit() {
    if (this.isDisabled) {
      this.currentState = TEXT_AREA_STATE.DISABLED;
      this.setDisabledState();
    }

    if (this.content) this.charCount = this.content.length;
  }

  public onTextChange(ev) {
    var textarea = ev.target;

    if (textarea.value === this.content) return;

    this.content = textarea.value;

    this.charCount = this.content.length;
    this.adjustHeight(textarea);

    if (this.charCount > this.maxCharacters - 10) {
      this.setWarningState(this.warningHelperText);
    }

    if (this.charCount > this.maxCharacters) {
      this.setErrorState(this.errorHelperText);
    }

    if (this.charCount <= this.maxCharacters - 10) {
      this.resetState();
    }

    this.onInputChange.emit(this.content);
  }

  onChangeFocus(focused) {
    this.isFocused = focused;
  }

  getTextAreaClass() {
    let textAreaClasses = "";

    if (this.isDisabled) textAreaClasses = "text-area-disabled";
    else if (
      this.isFocused &&
      this.currentState !== TEXT_AREA_STATE.WARNING &&
      this.currentState !== TEXT_AREA_STATE.ERROR
    ) {
      textAreaClasses = "text-area-focused";
    } else if (this.currentState == TEXT_AREA_STATE.WARNING)
      textAreaClasses = "text-area-warning";
    else if (this.currentState == TEXT_AREA_STATE.ERROR)
      textAreaClasses = "text-area-error";
    else textAreaClasses = "text-area-default";

    if (this.customCssClass) return `${textAreaClasses} ${this.customCssClass}`;

    return textAreaClasses;
  }

  getHelperText() {
    if (this.currentState == TEXT_AREA_STATE.WARNING)
      return this.warningHelperText;
    else if (this.currentState == TEXT_AREA_STATE.ERROR)
      return this.errorHelperText;
    else if (this.currentState == TEXT_AREA_STATE.SUCCESS)
      return this.successHelperText;
    else return this.helperText;
  }

  getHelperTextIconName() {
    if (
      ((this.currentState == TEXT_AREA_STATE.DEFAULT ||
        this.currentState == TEXT_AREA_STATE.DISABLED) &&
        this.helperText) ||
      (this.currentState == TEXT_AREA_STATE.WARNING &&
        this.warningHelperText) ||
      (this.currentState == TEXT_AREA_STATE.ERROR && this.errorHelperText) ||
      (this.currentState == TEXT_AREA_STATE.SUCCESS && this.successHelperText)
    ) {
      return this.helperTextIconName;
    }

    return null;
  }

  adjustHeight(textarea: any) {
    textarea.style.height = "auto";
    textarea.style.height = textarea.scrollHeight + "px";
  }

  resetState() {
    this.currentState = TEXT_AREA_STATE.DEFAULT;

    this.textAreaClass = "text-area-default";
    this.helperTextClass = "helper-text-default";
    this.helperTextIconName = "information-circle";
    this.counterTextClass = "counter-text-default";
    this.helperTextIconClass = "helper-text-icon-default";
  }

  setWarningState(warning: string = "") {
    this.currentState = TEXT_AREA_STATE.WARNING;

    this.helperTextIconName = "warning";
    this.textAreaClass = "text-area-warning";
    this.helperTextClass = "helper-text-warning";
    this.counterTextClass = "counter-text-warning";
    this.helperTextIconClass = "helper-text-icon-warning";
    this.warningHelperText = warning != "" ? warning : this.translate.instant('global.nearCharacterLimitRegex');
  }

  setErrorState(error: string = "") {
    this.currentState = TEXT_AREA_STATE.ERROR;

    this.textAreaClass = "text-area-error";
    this.helperTextClass = "helper-text-error";
    this.counterTextClass = "counter-text-error";
    this.helperTextIconName = "information-circle";
    this.helperTextIconClass = "helper-text-icon-error";
    this.errorHelperText = error != "" ? error : this.errorHelperText;
  }

  setSuccessState(success: string = "") {
    this.currentState = TEXT_AREA_STATE.SUCCESS;

    this.textAreaClass = "text-area-default";
    this.helperTextIconName = "checkmark-circle";
    this.helperTextClass = "helper-text-default";
    this.counterTextClass = "counter-text-default";
    this.helperTextIconClass = "helper-text-icon-success";
    this.successHelperText = success != "" ? success : this.successHelperText;
  }

  setDisabledState(helperText: string = "") {
    this.currentState = TEXT_AREA_STATE.DISABLED;

    this.textAreaClass = "text-area-disabled";
    this.helperTextClass = "helper-text-disabled";
    this.helperTextIconName = "information-circle";
    this.counterTextClass = "counter-text-disabled";
    this.helperTextIconClass = "helper-text-icon-disabled";
    this.helperText = helperText != "" ? helperText : this.helperText;
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-text-area/rmt-text-area.ts